import BotonManualHeader from "../../components/BotonManualHeader";
import React, { useState, useEffect } from "react";
import {
    Container,
    Card,
    Form,
    Button,
    Row,
    Col,
    Tab,
    Tabs,
    Spinner,
    Alert,
    Badge
} from "react-bootstrap";
import {
    FaSave,
    FaRegEye,
    FaCode,
    FaFileAlt,
    FaInfoCircle,
    FaCog,
    FaBuilding,
    FaPalette,
    FaTable,
    FaPlus,
    FaTrash,
    FaBold,
    FaAlignLeft,
    FaAlignCenter,
    FaAlignRight
} from "react-icons/fa";
import {
    getFirestore,
    collection,
    getDocs,
    doc,
    getDoc,
    setDoc,
    serverTimestamp
} from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import firebaseApp from "../../firebase/credenciales";
import Swal from "sweetalert2";
import { logBusinessAction } from "../../services/AuditService";

const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);

const PLACEHOLDER_LOGO = "https://placehold.co/150x60/e2e8f0/475569?text=Logo+Empresa";

// Función generadora de tablas SGI según el diseño (Layout) seleccionado
const generarTablaSGIHTML = (params) => {
    const {
        layout = "clasico",
        logo,
        nombreComercial,
        titulo,
        codigo,
        version,
        fecha,
        paginas,
        borderColor = "#333333",
        borderWidth = "2px",
        backgroundColor = "#ffffff",
        textColor = "#111111",
        fontFamily = "Arial, sans-serif",
        centroCeldas = [],
        derechaCeldas = [],
        logoSubTexto = "",
        logoSubTextoBold = false
    } = params;

    const currentLogo = logo || '{{LOGO}}';

    // Generar columna 1 (Logo) con sub-texto (ej. RUC) si existe
    let htmlLogo = "";
    if (logoSubTexto) {
        htmlLogo = `<table style="width: 100%; height: 100%; border-collapse: collapse; border: none; margin: 0; padding: 0; table-layout: fixed;">
          <tbody>
            <tr>
              <td style="border-bottom: 1px solid ${borderColor}; padding: 8px; text-align: center; vertical-align: middle;">
                <img src="${currentLogo}" alt="Logo" style="max-height: 48px; max-width: 100%; object-fit: contain; display: block; margin: 0 auto;" />
              </td>
            </tr>
            <tr>
              <td style="padding: 4px; text-align: center; font-size: 9px; ${logoSubTextoBold ? 'font-weight: bold;' : 'font-weight: normal;'}; font-family: ${fontFamily}; color: ${textColor}; overflow: hidden; word-wrap: break-word;">
                ${logoSubTexto}
              </td>
            </tr>
          </tbody>
        </table>`;
    } else {
        htmlLogo = `<img src="${currentLogo}" alt="Logo" style="max-height: 55px; max-width: 100%; object-fit: contain; display: block; margin: 0 auto;" />`;
    }

    if (layout === "dinamico" || layout === "grid") {
        // Generar tabla anidada de columna centro
        let htmlCentro = `<table style="width: 100%; height: 100%; border-collapse: collapse; border: none; margin: 0; padding: 0; table-layout: fixed;"><tbody>`;
        if (centroCeldas.length === 0) {
            htmlCentro += `<tr><td style="padding: 10px; text-align: center; font-size: 11px;">(Centro Vacío)</td></tr>`;
        } else {
            centroCeldas.forEach((celda, idx) => {
                const isLast = idx === centroCeldas.length - 1;
                const borderBottom = isLast ? "none" : `1px solid ${borderColor}`;
                const textStyle = celda.bold ? "font-weight: bold;" : "font-weight: normal;";
                
                const labelText = celda.label ? `<span style="font-weight: bold; margin-right: 5px;">${celda.label}</span>` : "";
                const valText = celda.value || "";

                htmlCentro += `<tr>
                  <td style="border-bottom: ${borderBottom}; padding: 8px; text-align: ${celda.align || 'center'}; vertical-align: middle; font-size: 11px; ${textStyle} word-wrap: break-word; overflow: hidden; font-family: ${fontFamily}; color: ${textColor};">
                    ${labelText}${valText}
                  </td>
                </tr>`;
            });
        }
        htmlCentro += `</tbody></table>`;

        // Generar tabla anidada de columna derecha
        let htmlDerecha = `<table style="width: 100%; height: 100%; border-collapse: collapse; border: none; margin: 0; padding: 0; table-layout: fixed;"><tbody>`;
        if (derechaCeldas.length === 0) {
            htmlDerecha += `<tr><td style="padding: 10px; text-align: center; font-size: 10px;">(Derecha Vacía)</td></tr>`;
        } else {
            derechaCeldas.forEach((celda, idx) => {
                const isLast = idx === derechaCeldas.length - 1;
                const borderBottom = isLast ? "none" : `1px solid ${borderColor}`;
                const textStyle = celda.bold ? "font-weight: bold;" : "font-weight: normal;";
                
                const labelText = celda.label ? `<span style="font-weight: bold; margin-right: 5px;">${celda.label}</span>` : "";
                const valText = celda.value || "";

                htmlDerecha += `<tr>
                  <td style="border-bottom: ${borderBottom}; padding: 6px 8px; text-align: ${celda.align || 'left'}; vertical-align: middle; font-size: 10px; ${textStyle} word-wrap: break-word; overflow: hidden; font-family: ${fontFamily}; color: ${textColor};">
                    ${labelText}${valText}
                  </td>
                </tr>`;
            });
        }
        htmlDerecha += `</tbody></table>`;
        return `<table style="width: 100%; border-collapse: collapse; border: ${borderWidth} solid ${borderColor}; font-family: ${fontFamily}; color: ${textColor}; margin-bottom: 15px; table-layout: fixed; vertical-align: stretch;">
  <tbody>
    <tr>
      <!-- Columna 1: Logo (25%) -->
      <td style="width: 25%; border-right: 1px solid ${borderColor}; text-align: center; vertical-align: middle; padding: ${logoSubTexto ? '0' : '10px'}; height: 1px; background-color: ${backgroundColor}; overflow: hidden;">
        ${htmlLogo}
      </td>
      <!-- Columna 2: Centro (50%) -->
      <td style="width: 50%; border-right: 1px solid ${borderColor}; padding: 0; height: 1px; vertical-align: stretch; background-color: ${backgroundColor};">
        ${htmlCentro}
      </td>
      <!-- Columna 3: Derecha (25%) -->
      <td style="width: 25%; padding: 0; height: 1px; vertical-align: stretch; background-color: ${backgroundColor === '#ffffff' ? '#fcfcfc' : backgroundColor};">
        ${htmlDerecha}
      </td>
    </tr>
  </tbody>
</table>`;
    }

    // Default: Layout clásico (3 columnas, metadatos apilados)
    let cellLogoPaddingClasico = logoSubTexto ? "0" : "10px";
    return `<table style="width: 100%; border-collapse: collapse; border: ${borderWidth} solid ${borderColor}; font-family: ${fontFamily}; color: ${textColor}; margin-bottom: 15px; table-layout: fixed;">
  <tbody>
    <tr>
      <!-- Columna 1: Logo (25% ancho) -->
      <td style="width: 25%; border-right: 1px solid ${borderColor}; text-align: center; vertical-align: middle; padding: ${cellLogoPaddingClasico}; background-color: ${backgroundColor}; overflow: hidden;">
        ${htmlLogo}
      </td>
      <!-- Columna 2: Título y Razón Social (50% ancho) -->
      <td style="width: 50%; border-right: 1px solid ${borderColor}; text-align: center; vertical-align: middle; padding: 8px; background-color: ${backgroundColor}; overflow: hidden; word-wrap: break-word;">
        <div style="font-size: 10px; font-weight: bold; text-transform: uppercase; color: #555555; margin-bottom: 3px; font-family: ${fontFamily};">${nombreComercial || '{{NOMBRE_COMERCIAL}}'}</div>
        <div style="font-size: 13px; font-weight: bold; color: ${textColor}; line-height: 1.2; font-family: ${fontFamily};">${titulo || '{{TITULO}}'}</div>
      </td>
      <!-- Columna 3: Metadatos SGI (25% ancho) -->
      <td style="width: 25%; font-size: 9px; padding: 6px; vertical-align: middle; background-color: ${backgroundColor === '#ffffff' ? '#fcfcfc' : backgroundColor}; font-family: ${fontFamily};">
        <table style="width: 100%; border-collapse: collapse; border: none; font-size: 9px; color: ${textColor}; font-family: ${fontFamily};">
          <tbody>
            <tr>
              <td style="font-weight: bold; padding: 1px 0; border: none; font-family: ${fontFamily};">Código:</td>
              <td style="padding: 1px 0; border: none; text-align: right; font-family: ${fontFamily};">${codigo || '{{CODIGO}}'}</td>
            </tr>
            <tr>
              <td style="font-weight: bold; padding: 1px 0; border: none; font-family: ${fontFamily};">Versión:</td>
              <td style="padding: 1px 0; border: none; text-align: right; font-family: ${fontFamily};">${version || '{{VERSION}}'}</td>
            </tr>
            <tr>
              <td style="font-weight: bold; padding: 1px 0; border: none; font-family: ${fontFamily};">Fecha:</td>
              <td style="padding: 1px 0; border: none; text-align: right; font-family: ${fontFamily};">${fecha || '{{FECHA}}'}</td>
            </tr>
            <tr>
              <td style="font-weight: bold; padding: 1px 0; border: none; font-family: ${fontFamily};">Página:</td>
              <td style="padding: 1px 0; border: none; text-align: right; font-family: ${fontFamily};">${paginas || '{{PAGINAS}}'}</td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
  </tbody>
</table>`;
};

// Resolver valor para el dropdown dependiendo del número de celdas
const resolveLayoutValue = (layout, derechaRows) => {
    if (layout === "grid") return "grid2";
    if (layout === "dinamico") {
        if (derechaRows.length === 2) return "grid2";
        if (derechaRows.length === 3) return "grid3";
        if (derechaRows.length === 4) return "grid4";
        return "dinamico";
    }
    return layout;
};

function EditorCabeceraSGI({ usuario }) {
    const rucEmpresa = usuario.ruc || "20538856674";

    // Estados de Carga
    const [loading, setLoading] = useState(true);
    const [guardando, setGuardando] = useState(false);
    const [subiendoLogo, setSubiendoLogo] = useState(false);

    // Lista de Formatos (proveniente de la lista maestra)
    const [formatos, setFormatos] = useState([]);

    // Configuración Global - Campos de Formulario
    const [nombreComercial, setNombreComercial] = useState("");
    const [logoUrl, setLogoUrl] = useState("");
    const [logoSubTexto, setLogoSubTexto] = useState("");
    const [logoSubTextoBold, setLogoSubTextoBold] = useState(false);
    const [globalLayout, setGlobalLayout] = useState("clasico"); // "clasico", "dinamico"
    const [globalBorderColor, setGlobalBorderColor] = useState("#333333");
    const [globalBorderWidth, setGlobalBorderWidth] = useState("2px");
    const [globalBgColor, setGlobalBgColor] = useState("#ffffff");
    const [globalTextColor, setGlobalTextColor] = useState("#111111");
    const [globalFontFamily, setGlobalFontFamily] = useState("Arial, sans-serif");
    
    // Configuración Global - Grilla Dinámica
    const [globalCentroRows, setGlobalCentroRows] = useState([
        { label: "", value: "{{NOMBRE_COMERCIAL}}", align: "center", bold: true },
        { label: "", value: "{{TITULO}}", align: "center", bold: true }
    ]);
    const [globalDerechaRows, setGlobalDerechaRows] = useState([
        { label: "Código:", value: "{{CODIGO}}", align: "left", bold: false },
        { label: "Versión:", value: "{{VERSION}}", align: "left", bold: false },
        { label: "Fecha:", value: "{{FECHA}}", align: "left", bold: false }
    ]);
    
    // Configuración Global - Código HTML Final
    const [globalCustomHTML, setGlobalCustomHTML] = useState("");
    const [editModeGlobal, setEditModeGlobal] = useState("form"); // "form" o "html"

    // Configuración Específica por Formato - Campos de Formulario
    const [selectedFormatoId, setSelectedFormatoId] = useState("");
    const [formatoTitulo, setFormatoTitulo] = useState("");
    const [formatoCodigo, setFormatoCodigo] = useState("");
    const [formatoVersion, setFormatoVersion] = useState("");
    const [formatoFecha, setFormatoFecha] = useState("");
    const [formatoPaginas, setFormatoPaginas] = useState("");
    const [formatoLogoSubTexto, setFormatoLogoSubTexto] = useState("");
    const [formatoLogoSubTextoBold, setFormatoLogoSubTextoBold] = useState(false);
    const [formatoLayout, setFormatoLayout] = useState("clasico"); // "clasico", "dinamico"
    
    // Configuración Específica por Formato - Grilla Dinámica
    const [formatoCentroRows, setFormatoCentroRows] = useState([]);
    const [formatoDerechaRows, setFormatoDerechaRows] = useState([]);
    
    // Configuración Específica por Formato - Estilos Propios
    const [formatoBorderColor, setFormatoBorderColor] = useState("#333333");
    const [formatoBorderWidth, setFormatoBorderWidth] = useState("2px");
    const [formatoBgColor, setFormatoBgColor] = useState("#ffffff");
    const [formatoTextColor, setFormatoTextColor] = useState("#111111");
    const [formatoFontFamily, setFormatoFontFamily] = useState("Arial, sans-serif");
    const [formatoPersonalizarEstilo, setFormatoPersonalizarEstilo] = useState(false);

    // Configuración Específica por Formato - Código HTML Final
    const [formatoCustomHTML, setFormatoCustomHTML] = useState("");
    const [editModeFormato, setEditModeFormato] = useState("form"); // "form" o "html"
    const [formatoOriginalData, setFormatoOriginalData] = useState(null);

    // Cargar información inicial
    useEffect(() => {
        const cargarDatos = async () => {
            try {
                setLoading(true);
                // 1. Obtener la Configuración Global de la Empresa
                const globalRef = doc(db, "headerSGI", rucEmpresa);
                const globalSnap = await getDoc(globalRef);

                let globalHtmlCargado = "";

                if (globalSnap.exists()) {
                    const data = globalSnap.data();
                    setNombreComercial(data.nombreComercial || usuario.empresaNombreComercial || usuario.empresa || "");
                    setLogoUrl(data.logoUrl || usuario.empresaLogo || "");
                    setLogoSubTexto(data.logoSubTexto || "");
                    setLogoSubTextoBold(data.logoSubTextoBold || false);
                    globalHtmlCargado = data.globalCustomHTML || data.html || "";
                    setGlobalCustomHTML(globalHtmlCargado);

                    // Cargar metadatos del formulario si existen
                    if (data.metadataForm) {
                        setGlobalLayout(data.metadataForm.layout || "clasico");
                        setGlobalBorderColor(data.metadataForm.borderColor || "#333333");
                        setGlobalBorderWidth(data.metadataForm.borderWidth || "2px");
                        setGlobalBgColor(data.metadataForm.backgroundColor || "#ffffff");
                        setGlobalTextColor(data.metadataForm.textColor || "#111111");
                        setGlobalFontFamily(data.metadataForm.fontFamily || "Arial, sans-serif");
                        setEditModeGlobal(data.metadataForm.editMode || "form");

                        if (data.metadataForm.centroCeldas) {
                            setGlobalCentroRows(data.metadataForm.centroCeldas);
                        }
                        if (data.metadataForm.derechaCeldas) {
                            setGlobalDerechaRows(data.metadataForm.derechaCeldas);
                        }
                    }
                } else {
                    setNombreComercial(usuario.empresaNombreComercial || usuario.empresa || "");
                    setLogoUrl(usuario.empresaLogo || "");
                    // RUC por defecto bajo el logo
                    setLogoSubTexto("R.U.C. " + rucEmpresa);
                }

                // Si no hay HTML cargado, generar uno inicial con los valores por defecto
                if (!globalHtmlCargado) {
                    const htmlInicial = generarTablaSGIHTML({
                        layout: "clasico",
                        logo: usuario.empresaLogo || "",
                        nombreComercial: usuario.empresaNombreComercial || usuario.empresa || "",
                        titulo: "{{TITULO}}",
                        codigo: "{{CODIGO}}",
                        version: "{{VERSION}}",
                        fecha: "{{FECHA}}",
                        paginas: "{{PAGINAS}}",
                        logoSubTexto: "R.U.C. " + rucEmpresa
                    });
                    setGlobalCustomHTML(htmlInicial);
                }

                // 2. Obtener lista de formatos de la colección headerSGI (ruta: /headerSGI/RUC/sgiFormatos)
                const sgiFormatosRef = collection(db, `headerSGI/${rucEmpresa}/sgiFormatos`);
                const sgiFormatosSnap = await getDocs(sgiFormatosRef);
                const listaFormatos = [];
                sgiFormatosSnap.forEach((doc) => {
                    const data = doc.data();
                    listaFormatos.push({
                        id: doc.id,
                        title: data.titulo || `Formato ${doc.id}`,
                        ...data
                    });
                });

                listaFormatos.sort((a, b) => parseInt(a.id) - parseInt(b.id));
                setFormatos(listaFormatos);

            } catch (error) {
                console.error("Error al cargar datos iniciales:", error);
                Swal.fire("Error", "No se pudo cargar la configuración de cabeceras", "error");
            } finally {
                setLoading(false);
            }
        };

        cargarDatos();
    }, [rucEmpresa, usuario]);

    // Cargar configuración de formato específico al seleccionar uno
    useEffect(() => {
        if (!selectedFormatoId) {
            setFormatoTitulo("");
            setFormatoCodigo("");
            setFormatoVersion("");
            setFormatoFecha("");
            setFormatoPaginas("");
            setFormatoLogoSubTexto("");
            setFormatoLogoSubTextoBold(false);
            setFormatoCustomHTML("");
            setFormatoOriginalData(null);
            setFormatoPersonalizarEstilo(false);
            setFormatoLayout("clasico");
            setFormatoCentroRows([]);
            setFormatoDerechaRows([]);
            return;
        }

        const cargarFormato = async () => {
            try {
                setLoading(true);
                const formatoRef = doc(db, `headerSGI/${rucEmpresa}/sgiFormatos`, selectedFormatoId);
                const formatoSnap = await getDoc(formatoRef);

                const formatoMaestro = formatos.find(f => f.id === selectedFormatoId);
                const tituloPorDefecto = formatoMaestro ? formatoMaestro.title : "";

                if (formatoSnap.exists()) {
                    const data = formatoSnap.data();
                    setFormatoTitulo(data.titulo || tituloPorDefecto);
                    setFormatoCodigo(data.codigo || "");
                    setFormatoVersion(data.version || "");
                    setFormatoFecha(data.fecha || "");
                    setFormatoPaginas(data.paginas || "1 de 1");
                    setFormatoLogoSubTexto(data.logoSubTexto || "");
                    setFormatoLogoSubTextoBold(data.logoSubTextoBold || false);
                    setFormatoCustomHTML(data.customHTML || data.html || "");
                    setFormatoOriginalData(data);

                    if (data.metadataForm) {
                        setFormatoLayout(data.metadataForm.layout || "clasico");
                        setFormatoBorderColor(data.metadataForm.borderColor || "#333333");
                        setFormatoBorderWidth(data.metadataForm.borderWidth || "2px");
                        setFormatoBgColor(data.metadataForm.backgroundColor || "#ffffff");
                        setFormatoTextColor(data.metadataForm.textColor || "#111111");
                        setFormatoFontFamily(data.metadataForm.fontFamily || "Arial, sans-serif");
                        setFormatoPersonalizarEstilo(data.metadataForm.personalizarEstilo || false);
                        setEditModeFormato(data.metadataForm.editMode || "form");
                        
                        setFormatoCentroRows(data.metadataForm.centroCeldas || globalCentroRows);
                        setFormatoDerechaRows(data.metadataForm.derechaCeldas || globalDerechaRows);
                    } else {
                        setFormatoPersonalizarEstilo(false);
                        setEditModeFormato("form");
                        setFormatoLayout("clasico");
                        setFormatoCentroRows(globalCentroRows);
                        setFormatoDerechaRows(globalDerechaRows);
                    }
                } else {
                    setFormatoTitulo(tituloPorDefecto);
                    setFormatoCodigo("");
                    setFormatoVersion("01");
                    setFormatoFecha(new Date().toLocaleDateString("es-PE"));
                    setFormatoPaginas("1 de 1");
                    setFormatoCustomHTML("");
                    setFormatoOriginalData(null);
                    setFormatoPersonalizarEstilo(false);
                    setEditModeFormato("form");
                    setFormatoLayout(globalLayout); // Heredar layout actual
                    
                    // Heredar RUC/Sub-texto del global
                    setFormatoLogoSubTexto(logoSubTexto);
                    setFormatoLogoSubTextoBold(logoSubTextoBold);
                    
                    // Inicializar celdas dinámicas heredadas
                    setFormatoCentroRows(JSON.parse(JSON.stringify(globalCentroRows)));
                    setFormatoDerechaRows(JSON.parse(JSON.stringify(globalDerechaRows)));
                    
                    // Inicializar estilos del formato heredados del global
                    setFormatoBorderColor(globalBorderColor);
                    setFormatoBorderWidth(globalBorderWidth);
                    setFormatoBgColor(globalBgColor);
                    setFormatoTextColor(globalTextColor);
                    setFormatoFontFamily(globalFontFamily);
                }
            } catch (error) {
                console.error("Error al obtener formato específico:", error);
                Swal.fire("Error", "No se pudo cargar la configuración del formato", "error");
            } finally {
                setLoading(false);
            }
        };

        cargarFormato();
    }, [selectedFormatoId, rucEmpresa, formatos, globalLayout, logoSubTexto, logoSubTextoBold, globalBorderColor, globalBorderWidth, globalBgColor, globalTextColor, globalFontFamily, globalCentroRows, globalDerechaRows]);

    // Regenerar HTML Global automáticamente en modo Formulario
    useEffect(() => {
        if (editModeGlobal === "form" && !loading) {
            const html = generarTablaSGIHTML({
                layout: globalLayout,
                logo: logoUrl,
                nombreComercial,
                titulo: "{{TITULO}}",
                codigo: "{{CODIGO}}",
                version: "{{VERSION}}",
                fecha: "{{FECHA}}",
                paginas: "{{PAGINAS}}",
                borderColor: globalBorderColor,
                borderWidth: globalBorderWidth,
                backgroundColor: globalBgColor,
                textColor: globalTextColor,
                fontFamily: globalFontFamily,
                centroCeldas: globalCentroRows,
                derechaCeldas: globalDerechaRows,
                logoSubTexto,
                logoSubTextoBold
            });
            setGlobalCustomHTML(html);
        }
    }, [editModeGlobal, globalLayout, nombreComercial, logoUrl, globalBorderColor, globalBorderWidth, globalBgColor, globalTextColor, globalFontFamily, globalCentroRows, globalDerechaRows, logoSubTexto, logoSubTextoBold, loading]);

    // Regenerar HTML de Formato automáticamente en modo Formulario
    useEffect(() => {
        if (editModeFormato === "form" && selectedFormatoId && !loading) {
            const currentBorderColor = formatoPersonalizarEstilo ? formatoBorderColor : globalBorderColor;
            const currentBorderWidth = formatoPersonalizarEstilo ? formatoBorderWidth : globalBorderWidth;
            const currentBgColor = formatoPersonalizarEstilo ? formatoBgColor : globalBgColor;
            const currentTextColor = formatoPersonalizarEstilo ? formatoTextColor : globalTextColor;
            const currentFontFamily = formatoPersonalizarEstilo ? formatoFontFamily : globalFontFamily;

            const html = generarTablaSGIHTML({
                layout: formatoLayout,
                logo: logoUrl,
                nombreComercial,
                titulo: formatoTitulo,
                codigo: formatoCodigo,
                version: formatoVersion,
                fecha: formatoFecha,
                paginas: formatoPaginas,
                borderColor: currentBorderColor,
                borderWidth: currentBorderWidth,
                backgroundColor: currentBgColor,
                textColor: currentTextColor,
                fontFamily: currentFontFamily,
                centroCeldas: formatoCentroRows,
                derechaCeldas: formatoDerechaRows,
                logoSubTexto: formatoLogoSubTexto,
                logoSubTextoBold: formatoLogoSubTextoBold
            });
            setFormatoCustomHTML(html);
        }
    }, [editModeFormato, formatoLayout, selectedFormatoId, formatoTitulo, formatoCodigo, formatoVersion, formatoFecha, formatoPaginas, logoUrl, nombreComercial, formatoPersonalizarEstilo, formatoBorderColor, formatoBorderWidth, formatoBgColor, formatoTextColor, formatoFontFamily, formatoCentroRows, formatoDerechaRows, formatoLogoSubTexto, formatoLogoSubTextoBold, globalBorderColor, globalBorderWidth, globalBgColor, globalTextColor, globalFontFamily, loading]);

    // Manejar la selección del layout desde el menú desplegable superior
    const handleSelectLayout = (layoutVal, type = "global") => {
        if (type === "global") {
            if (layoutVal === "grid2") {
                setGlobalLayout("dinamico");
                setGlobalCentroRows([
                    { label: "", value: "{{NOMBRE_COMERCIAL}}", align: "center", bold: true },
                    { label: "", value: "{{TITULO}}", align: "center", bold: true }
                ]);
                setGlobalDerechaRows([
                    { label: "Revisión:", value: "{{VERSION}}", align: "left", bold: false },
                    { label: "Fecha:", value: "{{FECHA}}", align: "left", bold: false }
                ]);
            } else if (layoutVal === "grid3") {
                setGlobalLayout("dinamico");
                setGlobalCentroRows([
                    { label: "", value: "{{NOMBRE_COMERCIAL}}", align: "center", bold: true },
                    { label: "", value: "{{TITULO}}", align: "center", bold: true }
                ]);
                setGlobalDerechaRows([
                    { label: "Código:", value: "{{CODIGO}}", align: "left", bold: false },
                    { label: "Versión:", value: "{{VERSION}}", align: "left", bold: false },
                    { label: "Fecha:", value: "{{FECHA}}", align: "left", bold: false }
                ]);
            } else if (layoutVal === "grid4") {
                setGlobalLayout("dinamico");
                setGlobalCentroRows([
                    { label: "", value: "{{NOMBRE_COMERCIAL}}", align: "center", bold: true },
                    { label: "", value: "{{TITULO}}", align: "center", bold: true }
                ]);
                setGlobalDerechaRows([
                    { label: "Código:", value: "{{CODIGO}}", align: "left", bold: false },
                    { label: "Versión:", value: "{{VERSION}}", align: "left", bold: false },
                    { label: "Fecha:", value: "{{FECHA}}", align: "left", bold: false },
                    { label: "Página:", value: "{{PAGINAS}}", align: "left", bold: false }
                ]);
            } else {
                setGlobalLayout(layoutVal);
            }
        } else {
            // For Formato
            if (layoutVal === "grid2") {
                setFormatoLayout("dinamico");
                setFormatoCentroRows([
                    { label: "", value: formatoTitulo || "{{TITULO}}", align: "center", bold: true },
                    { label: "", value: formatoCodigo || "{{CODIGO}}", align: "center", bold: true }
                ]);
                setFormatoDerechaRows([
                    { label: "Revisión:", value: "{{VERSION}}", align: "left", bold: false },
                    { label: "Fecha:", value: "{{FECHA}}", align: "left", bold: false }
                ]);
            } else if (layoutVal === "grid3") {
                setFormatoLayout("dinamico");
                setFormatoCentroRows([
                    { label: "", value: formatoTitulo || "{{TITULO}}", align: "center", bold: true },
                    { label: "", value: formatoCodigo || "{{CODIGO}}", align: "center", bold: true }
                ]);
                setFormatoDerechaRows([
                    { label: "Código:", value: "{{CODIGO}}", align: "left", bold: false },
                    { label: "Versión:", value: "{{VERSION}}", align: "left", bold: false },
                    { label: "Fecha:", value: "{{FECHA}}", align: "left", bold: false }
                ]);
            } else if (layoutVal === "grid4") {
                setFormatoLayout("dinamico");
                setFormatoCentroRows([
                    { label: "", value: formatoTitulo || "{{TITULO}}", align: "center", bold: true },
                    { label: "", value: formatoCodigo || "{{CODIGO}}", align: "center", bold: true }
                ]);
                setFormatoDerechaRows([
                    { label: "Código:", value: "{{CODIGO}}", align: "left", bold: false },
                    { label: "Versión:", value: "{{VERSION}}", align: "left", bold: false },
                    { label: "Fecha:", value: "{{FECHA}}", align: "left", bold: false },
                    { label: "Página:", value: "{{PAGINAS}}", align: "left", bold: false }
                ]);
            } else {
                setFormatoLayout(layoutVal);
            }
        }
    };

    // Función para cambiar el tamaño de la columna derecha usando el selector rápido
    const handleAjustarCeldasDerecha = (cantidad, rows, setRows) => {
        const num = parseInt(cantidad);
        let nuevasCeldas = [...rows];
        if (nuevasCeldas.length < num) {
            const diff = num - nuevasCeldas.length;
            for (let i = 0; i < diff; i++) {
                const idx = nuevasCeldas.length;
                let label = "";
                let value = "";
                if (idx === 0) { label = "Código:"; value = "{{CODIGO}}"; }
                else if (idx === 1) { label = "Versión:"; value = "{{VERSION}}"; }
                else if (idx === 2) { label = "Fecha:"; value = "{{FECHA}}"; }
                else if (idx === 3) { label = "Página:"; value = "{{PAGINAS}}"; }
                nuevasCeldas.push({ label, value, align: "left", bold: false });
            }
        } else if (nuevasCeldas.length > num) {
            nuevasCeldas = nuevasCeldas.slice(0, num);
        }
        setRows(nuevasCeldas);
    };

    // Gestión del Formulario Dinámico (Global)
    const handleUpdateCelda = (columna, index, key, valor) => {
        if (columna === "centro") {
            setGlobalCentroRows(prev => prev.map((row, idx) => idx === index ? { ...row, [key]: valor } : row));
        } else {
            setGlobalDerechaRows(prev => prev.map((row, idx) => idx === index ? { ...row, [key]: valor } : row));
        }
    };

    const handleAddFila = (columna) => {
        const nuevaFila = { label: "", value: "", align: columna === "centro" ? "center" : "left", bold: false };
        if (columna === "centro") {
            setGlobalCentroRows(prev => [...prev, nuevaFila]);
        } else {
            setGlobalDerechaRows(prev => [...prev, nuevaFila]);
        }
    };

    const handleRemoveFila = (columna, index) => {
        if (columna === "centro") {
            setGlobalCentroRows(prev => prev.filter((_, idx) => idx !== index));
        } else {
            setGlobalDerechaRows(prev => prev.filter((_, idx) => idx !== index));
        }
    };

    // Gestión del Formulario Dinámico (Formato)
    const handleUpdateFormatoCelda = (columna, index, key, valor) => {
        if (columna === "centro") {
            setFormatoCentroRows(prev => prev.map((row, idx) => idx === index ? { ...row, [key]: valor } : row));
        } else {
            setFormatoDerechaRows(prev => prev.map((row, idx) => idx === index ? { ...row, [key]: valor } : row));
        }
    };

    const handleAddFormatoFila = (columna) => {
        const nuevaFila = { label: "", value: "", align: columna === "centro" ? "center" : "left", bold: false };
        if (columna === "centro") {
            setFormatoCentroRows(prev => [...prev, nuevaFila]);
        } else {
            setFormatoDerechaRows(prev => [...prev, nuevaFila]);
        }
    };

    const handleRemoveFormatoFila = (columna, index) => {
        if (columna === "centro") {
            setFormatoCentroRows(prev => prev.filter((_, idx) => idx !== index));
        } else {
            setFormatoDerechaRows(prev => prev.filter((_, idx) => idx !== index));
        }
    };

    // Subir Logotipo a Storage
    const handleSubirLogo = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (!file.type.startsWith("image/")) {
            Swal.fire("Archivo no válido", "Por favor, seleccione una imagen (PNG, JPG, SVG)", "warning");
            return;
        }

        try {
            setSubiendoLogo(true);
            const ext = file.name.split(".").pop();
            const storageRef = ref(storage, `onboarding_headers/logos/${rucEmpresa}_${Date.now()}.${ext}`);
            const uploadResult = await uploadBytes(storageRef, file);
            const downloadUrl = await getDownloadURL(uploadResult.ref);

            setLogoUrl(downloadUrl);
            Swal.fire("¡Éxito!", "Logotipo cargado y actualizado", "success");
        } catch (error) {
            console.error("Error al subir logotipo:", error);
            Swal.fire("Error", "Hubo un error al subir el logotipo a Firebase Storage", "error");
        } finally {
            setSubiendoLogo(false);
        }
    };

    // Guardar Configuración Global
    const guardarGlobal = async () => {
        if (!nombreComercial.trim()) {
            Swal.fire("Campo requerido", "Debe ingresar el Nombre Comercial", "warning");
            return;
        }

        try {
            setGuardando(true);
            const globalRef = doc(db, "headerSGI", rucEmpresa);
            await setDoc(globalRef, {
                nombreComercial,
                logoUrl,
                logoSubTexto,
                logoSubTextoBold,
                globalCustomHTML,
                html: globalCustomHTML,
                metadataForm: {
                    layout: globalLayout,
                    borderColor: globalBorderColor,
                    borderWidth: globalBorderWidth,
                    backgroundColor: globalBgColor,
                    textColor: globalTextColor,
                    fontFamily: globalFontFamily,
                    editMode: editModeGlobal,
                    centroCeldas: globalCentroRows,
                    derechaCeldas: globalDerechaRows
                },
                actualizadoEl: serverTimestamp(),
                actualizadoPor: usuario.email || usuario.nombre
            }, { merge: true });

            // AUDITORÍA
            try {
                await logBusinessAction("CONFIG_GLOBAL_CABECERA_SGI", "GestionOnboarding", {
                    ruc: rucEmpresa,
                    nombreComercial,
                    layout: globalLayout,
                    logoUrl: logoUrl ? "Cargado" : "Vacío"
                }, usuario);
            } catch (e) {
                console.warn("Error en registro de auditoría:", e);
            }

            Swal.fire("¡Guardado!", "Configuración global de cabecera guardada correctamente", "success");
        } catch (error) {
            console.error("Error al guardar configuración global:", error);
            Swal.fire("Error", "No se pudo guardar la configuración global", "error");
        } finally {
            setGuardando(false);
        }
    };

    // Guardar Configuración del Formato
    const guardarFormato = async () => {
        if (!selectedFormatoId) return;

        try {
            setGuardando(true);
            const formatoRef = doc(db, `headerSGI/${rucEmpresa}/sgiFormatos`, selectedFormatoId);
            await setDoc(formatoRef, {
                titulo: formatoTitulo,
                codigo: formatoCodigo,
                version: formatoVersion,
                fecha: formatoFecha,
                paginas: formatoPaginas,
                logoSubTexto: formatoLogoSubTexto,
                logoSubTextoBold: formatoLogoSubTextoBold,
                customHTML: formatoCustomHTML,
                html: formatoCustomHTML,
                metadataForm: {
                    layout: formatoLayout,
                    borderColor: formatoBorderColor,
                    borderWidth: formatoBorderWidth,
                    backgroundColor: formatoBgColor,
                    textColor: formatoTextColor,
                    fontFamily: formatoFontFamily,
                    personalizarEstilo: formatoPersonalizarEstilo,
                    editMode: editModeFormato,
                    centroCeldas: formatoCentroRows,
                    derechaCeldas: formatoDerechaRows
                },
                actualizadoEl: serverTimestamp(),
                actualizadoPor: usuario.email || usuario.nombre
            });

            // AUDITORÍA
            try {
                await logBusinessAction("CONFIG_FORMATO_CABECERA_SGI", "GestionOnboarding", {
                    ruc: rucEmpresa,
                    formatoId: selectedFormatoId,
                    titulo: formatoTitulo,
                    codigo: formatoCodigo,
                    version: formatoVersion,
                    layout: formatoLayout
                }, usuario);
            } catch (e) {
                console.warn("Error en registro de auditoría:", e);
            }

            Swal.fire("¡Guardado!", "Configuración del formato guardada correctamente", "success");
            
            setFormatoOriginalData({
                titulo: formatoTitulo,
                codigo: formatoCodigo,
                version: formatoVersion,
                fecha: formatoFecha,
                paginas: formatoPaginas,
                logoSubTexto: formatoLogoSubTexto,
                logoSubTextoBold: formatoLogoSubTextoBold,
                customHTML: formatoCustomHTML,
                html: formatoCustomHTML,
                metadataForm: {
                    layout: formatoLayout,
                    borderColor: formatoBorderColor,
                    borderWidth: formatoBorderWidth,
                    backgroundColor: formatoBgColor,
                    textColor: formatoTextColor,
                    fontFamily: formatoFontFamily,
                    personalizarEstilo: formatoPersonalizarEstilo,
                    editMode: editModeFormato,
                    centroCeldas: formatoCentroRows,
                    derechaCeldas: formatoDerechaRows
                }
            });
        } catch (error) {
            console.error("Error al guardar formato específico:", error);
            Swal.fire("Error", "No se pudo guardar la configuración del formato", "error");
        } finally {
            setGuardando(false);
        }
    };

    // Restablecer formato específico
    const eliminarConfiguracionFormato = async () => {
        if (!selectedFormatoId) return;

        const confirmacion = await Swal.fire({
            title: "¿Restablecer formato?",
            text: "Se eliminarán los metadatos y HTML personalizado de este formato. Pasará a heredar la cabecera global de la empresa.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, restablecer",
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#d33"
        });

        if (!confirmacion.isConfirmed) return;

        try {
            setGuardando(true);
            const { deleteDoc, doc } = await import("firebase/firestore");
            const formatoRef = doc(db, `headerSGI/${rucEmpresa}/sgiFormatos`, selectedFormatoId);
            await deleteDoc(formatoRef);

            setFormatoTitulo("");
            setFormatoCodigo("");
            setFormatoVersion("");
            setFormatoFecha("");
            setFormatoPaginas("");
            setFormatoLogoSubTexto("");
            setFormatoLogoSubTextoBold(false);
            setFormatoCustomHTML("");
            setFormatoOriginalData(null);
            setFormatoPersonalizarEstilo(false);
            setFormatoLayout("clasico");
            setFormatoCentroRows(JSON.parse(JSON.stringify(globalCentroRows)));
            setFormatoDerechaRows(JSON.parse(JSON.stringify(globalDerechaRows)));
            setEditModeFormato("form");

            Swal.fire("Restablecido", "El formato ahora heredará la configuración global", "success");
        } catch (error) {
            console.error("Error al eliminar formato específico:", error);
            Swal.fire("Error", "No se pudo restablecer la configuración del formato", "error");
        } finally {
            setGuardando(false);
        }
    };

    // Compilar placeholders para la previsualización final
    const compilarHTML = (htmlString, isFormatTab = false) => {
        if (!htmlString) return "<div class='text-muted text-center p-3'>No hay contenido HTML para mostrar en la vista previa.</div>";

        const currentLogo = logoUrl || PLACEHOLDER_LOGO;
        const currentNombre = nombreComercial || "Nombre Comercial";

        let currentTitulo = "TÍTULO DEL DOCUMENTO";
        let currentCodigo = "FOR-XX-000";
        let currentVersion = "01";
        let currentFecha = new Date().toLocaleDateString("es-PE");
        let currentPaginas = "1 de 1";

        if (isFormatTab && selectedFormatoId) {
            currentTitulo = formatoTitulo || formatos.find(f => f.id === selectedFormatoId)?.title || currentTitulo;
            currentCodigo = formatoCodigo || currentCodigo;
            currentVersion = formatoVersion || currentVersion;
            currentFecha = formatoFecha || currentFecha;
            currentPaginas = formatoPaginas || currentPaginas;
        }

        return htmlString
            .replace(/\{\{LOGO\}\}/g, currentLogo)
            .replace(/\{\{LOGO_URL\}\}/g, currentLogo)
            .replace(/\{\{NOMBRE_COMERCIAL\}\}/g, currentNombre)
            .replace(/\{\{TITULO\}\}/g, currentTitulo)
            .replace(/\{\{CODIGO\}\}/g, currentCodigo)
            .replace(/\{\{VERSION\}\}/g, currentVersion)
            .replace(/\{\{FECHA\}\}/g, currentFecha)
            .replace(/\{\{PAGINAS\}\}/g, currentPaginas);
    };

    // Restaurar valores por defecto de la plantilla
    const restaurarPlantillaPorDefecto = (isGlobal = true) => {
        Swal.fire({
            title: "¿Restablecer diseño base?",
            text: "Se generará un diseño SGI limpio basado en los campos actuales del formulario.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, restablecer",
            cancelButtonText: "Cancelar"
        }).then((result) => {
            if (result.isConfirmed) {
                if (isGlobal) {
                    const html = generarTablaSGIHTML({
                        layout: globalLayout,
                        logo: logoUrl,
                        nombreComercial,
                        titulo: "{{TITULO}}",
                        codigo: "{{CODIGO}}",
                        version: "{{VERSION}}",
                        fecha: "{{FECHA}}",
                        paginas: "{{PAGINAS}}",
                        borderColor: globalBorderColor,
                        borderWidth: globalBorderWidth,
                        backgroundColor: globalBgColor,
                        textColor: globalTextColor,
                        fontFamily: globalFontFamily,
                        centroCeldas: globalCentroRows,
                        derechaCeldas: globalDerechaRows,
                        logoSubTexto,
                        logoSubTextoBold
                    });
                    setGlobalCustomHTML(html);
                } else {
                    const currentBorderColor = formatoPersonalizarEstilo ? formatoBorderColor : globalBorderColor;
                    const currentBorderWidth = formatoPersonalizarEstilo ? formatoBorderWidth : globalBorderWidth;
                    const currentBgColor = formatoPersonalizarEstilo ? formatoBgColor : globalBgColor;
                    const currentTextColor = formatoPersonalizarEstilo ? formatoTextColor : globalTextColor;
                    const currentFontFamily = formatoPersonalizarEstilo ? formatoFontFamily : globalFontFamily;

                    const html = generarTablaSGIHTML({
                        layout: formatoLayout,
                        logo: logoUrl,
                        nombreComercial,
                        titulo: formatoTitulo,
                        codigo: formatoCodigo,
                        version: formatoVersion,
                        fecha: formatoFecha,
                        paginas: formatoPaginas,
                        borderColor: currentBorderColor,
                        borderWidth: currentBorderWidth,
                        backgroundColor: currentBgColor,
                        textColor: currentTextColor,
                        fontFamily: currentFontFamily,
                        centroCeldas: formatoCentroRows,
                        derechaCeldas: formatoDerechaRows,
                        logoSubTexto: formatoLogoSubTexto,
                        logoSubTextoBold: formatoLogoSubTextoBold
                    });
                    setFormatoCustomHTML(html);
                }
            }
        });
    };

    // Renderizar los controles dinámicos de las filas
    const renderFilaCustomizer = (columna, rows, onUpdate, onRemove, onAdd, onAjustar) => {
        const setRows = (nuevasRows) => {
            if (columna === "centro") {
                setGlobalCentroRows(nuevasRows);
            } else {
                setGlobalDerechaRows(nuevasRows);
            }
        };

        const setFormatoRows = (nuevasRows) => {
            if (columna === "centro") {
                setFormatoCentroRows(nuevasRows);
            } else {
                setFormatoDerechaRows(nuevasRows);
            }
        };

        const currentSetRows = selectedFormatoId ? setFormatoRows : setRows;

        return (
            <div className="p-3 bg-white border rounded mb-3 shadow-sm">
                <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                    <h6 className="fw-bold mb-0 text-secondary d-flex align-items-center">
                        <FaTable className="me-2 text-primary" />
                        Celdas de Columna {columna === "centro" ? "Centro (Título)" : "Derecha (Metadatos)"}
                    </h6>
                    
                    <div className="d-flex align-items-center gap-2">
                        {columna === "derecha" && onAjustar && (
                            <>
                                <Form.Label className="mb-0 small fw-semibold text-muted">Tamaño Rápido:</Form.Label>
                                <Form.Select 
                                    size="sm" 
                                    value={rows.length <= 4 && rows.length >= 2 ? rows.length : ""} 
                                    onChange={(e) => onAjustar(e.target.value, rows, currentSetRows)}
                                    style={{ width: "120px", borderRadius: "6px", marginRight: "10px" }}
                                >
                                    <option value="" disabled>Personalizado</option>
                                    <option value="2">2 Celdas</option>
                                    <option value="3">3 Celdas</option>
                                    <option value="4">4 Celdas</option>
                                </Form.Select>
                            </>
                        )}
                        <Button variant="outline-success" size="sm" onClick={() => onAdd(columna)} style={{ borderRadius: "8px" }}>
                            <FaPlus className="me-1" /> Añadir Fila
                        </Button>
                    </div>
                </div>
                
                {rows.length === 0 ? (
                    <div className="text-center py-3 text-muted bg-light rounded border border-dashed">
                        No hay celdas configuradas. Presione "Añadir Fila".
                    </div>
                ) : (
                    rows.map((row, idx) => (
                        <Row key={idx} className="align-items-center mb-2 g-2 p-2 border-bottom">
                            <Col xs={1} className="text-center small fw-bold text-muted">
                                #{idx + 1}
                            </Col>
                            <Col md={3}>
                                <Form.Control
                                    type="text"
                                    placeholder="Etiqueta (ej: Código:)"
                                    value={row.label}
                                    onChange={(e) => onUpdate(columna, idx, "label", e.target.value)}
                                    size="sm"
                                    style={{ borderRadius: "6px" }}
                                />
                            </Col>
                            <Col md={4}>
                                <Form.Control
                                    type="text"
                                    placeholder="Valor / Placeholder"
                                    value={row.value}
                                    onChange={(e) => onUpdate(columna, idx, "value", e.target.value)}
                                    size="sm"
                                    style={{ borderRadius: "6px" }}
                                />
                                <div className="mt-1 d-flex gap-1 flex-wrap">
                                    {["{{TITULO}}", "{{CODIGO}}", "{{VERSION}}", "{{FECHA}}", "{{PAGINAS}}"].map(p => (
                                        <Badge 
                                            key={p} 
                                            bg="light" 
                                            text="dark" 
                                            className="border cursor-pointer px-1 py-0.5" 
                                            style={{ fontSize: "0.7rem" }}
                                            onClick={() => onUpdate(columna, idx, "value", row.value + p)}
                                        >
                                            +{p}
                                        </Badge>
                                    ))}
                                </div>
                            </Col>
                            <Col md={2} className="d-flex justify-content-center gap-1">
                                <Button 
                                    variant={row.align === "left" ? "primary" : "light"} 
                                    size="sm" 
                                    className="border"
                                    onClick={() => onUpdate(columna, idx, "align", "left")}
                                    title="Alinear Izquierda"
                                >
                                    <FaAlignLeft size={10} />
                                </Button>
                                <Button 
                                    variant={row.align === "center" ? "primary" : "light"} 
                                    size="sm" 
                                    className="border"
                                    onClick={() => onUpdate(columna, idx, "align", "center")}
                                    title="Alinear Centro"
                                >
                                    <FaAlignCenter size={10} />
                                </Button>
                                <Button 
                                    variant={row.align === "right" ? "primary" : "light"} 
                                    size="sm" 
                                    className="border"
                                    onClick={() => onUpdate(columna, idx, "align", "right")}
                                    title="Alinear Derecha"
                                >
                                    <FaAlignRight size={10} />
                                </Button>
                            </Col>
                            <Col xs="auto" className="d-flex align-items-center gap-1">
                                <Button 
                                    variant={row.bold ? "primary" : "light"} 
                                    size="sm" 
                                    className="border"
                                    onClick={() => onUpdate(columna, idx, "bold", !row.bold)}
                                    title="Texto en Negrita"
                                >
                                    <FaBold size={10} />
                                </Button>
                                <Button 
                                    variant="outline-danger" 
                                    size="sm" 
                                    onClick={() => onRemove(columna, idx)}
                                    title="Eliminar fila"
                                >
                                    <FaTrash size={10} />
                                </Button>
                            </Col>
                        </Row>
                    ))
                )}
            </div>
        );
    };

    return (
        <div
            className="min-vh-100"
            style={{
                background: "linear-gradient(135deg, #ffffff 0%, #ffffff 100%)",
                padding: "20px 0",
            }}
        >
            <Container fluid style={{ width: "95%", maxWidth: "100%" }}>
                <Card className="shadow-lg border-0" style={{ borderRadius: "15px", overflow: "hidden" }}>
                    {/* Header Premium */}
                    <Card.Header
                        className="text-white py-4 position-relative"
                        style={{
                            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                            borderBottom: "3px solid #f39c12",
                        }}
                    >
                        <div className="d-flex align-items-center justify-content-center w-100">
                            <div className="text-center">
                                <h2 className="fw-bold mb-1">
                                    <FaCog className="me-3" />
                                    Editor de Cabeceras SGI
                                </h2>
                                <p className="mb-0 opacity-75">
                                    Configuración visual dinámica de cabeceras de documentos SGI de Onboarding (Tablas de 3 Columnas)
                                </p>
                            </div>
                            <div style={{ position: "absolute", right: "20px" }}>
                                <BotonManualHeader usuario={usuario} />
                            </div>
                        </div>
                    </Card.Header>

                    <Card.Body className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
                        {loading && !guardando && (
                            <div className="text-center py-5">
                                <Spinner animation="border" variant="primary" style={{ width: "3rem", height: "3rem" }} />
                                <h5 className="mt-3 text-muted">Cargando datos de configuración...</h5>
                            </div>
                        )}

                        {!loading && (
                            <Tabs defaultActiveKey="global" id="editor-cabecera-tabs" className="mb-4 custom-tabs-sgi" style={{ borderBottom: "2px solid #e2e8f0" }}>
                                {/* PESTAÑA CONFIGURACIÓN GLOBAL */}
                                <Tab
                                    eventKey="global"
                                    title={
                                        <span>
                                            <FaBuilding className="me-2" />
                                            1. Configuración Global de Empresa
                                        </span>
                                    }
                                >
                                    <Row className="mt-3">
                                        <Col lg={7}>
                                            <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: "12px" }}>
                                                <Card.Body className="p-4">
                                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                                        <h5 className="fw-bold mb-0 text-primary d-flex align-items-center">
                                                            <FaBuilding className="me-2" /> Datos Generales de la Empresa
                                                        </h5>
                                                        <div className="d-flex gap-2">
                                                            <Button
                                                                variant={editModeGlobal === "form" ? "primary" : "outline-primary"}
                                                                size="sm"
                                                                onClick={() => setEditModeGlobal("form")}
                                                                style={{ borderRadius: "8px" }}
                                                            >
                                                                <FaTable className="me-1" /> Generador SGI (Recomendado)
                                                            </Button>
                                                            <Button
                                                                variant={editModeGlobal === "html" ? "primary" : "outline-primary"}
                                                                size="sm"
                                                                onClick={() => setEditModeGlobal("html")}
                                                                style={{ borderRadius: "8px" }}
                                                            >
                                                                <FaCode className="me-1" /> Código Fuente HTML
                                                            </Button>
                                                        </div>
                                                    </div>

                                                    {editModeGlobal === "form" ? (
                                                        <>
                                                            <Row>
                                                                <Col md={12} className="mb-3">
                                                                    <Form.Group>
                                                                        <Form.Label className="fw-bold text-secondary">Estructura / Diseño de Cabecera</Form.Label>
                                                                        <Form.Select
                                                                            value={resolveLayoutValue(globalLayout, globalDerechaRows)}
                                                                            onChange={(e) => handleSelectLayout(e.target.value, "global")}
                                                                            style={{ borderRadius: "10px", border: "2px solid #667eea" }}
                                                                            className="form-control-lg fw-semibold"
                                                                        >
                                                                            <option value="clasico">SGI Clásico (3 columnas, 4 metadatos apilados)</option>
                                                                            <option value="grid2">SGI Grilla - 2 Celdas a la derecha (Logo spans 2 filas)</option>
                                                                            <option value="grid3">SGI Grilla - 3 Celdas a la derecha (Logo spans 3 filas)</option>
                                                                            <option value="grid4">SGI Grilla - 4 Celdas a la derecha (Logo spans 4 filas)</option>
                                                                            <option value="dinamico">Diseño Dinámico por Filas (Personalizado total)</option>
                                                                        </Form.Select>
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col md={6}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label className="fw-semibold">Razón / Nombre Comercial</Form.Label>
                                                                        <Form.Control
                                                                            type="text"
                                                                            placeholder="Ej. Mi Empresa S.A.C."
                                                                            value={nombreComercial}
                                                                            onChange={(e) => setNombreComercial(e.target.value)}
                                                                            style={{ borderRadius: "8px" }}
                                                                            disabled={globalLayout === "grid" || globalLayout === "dinamico"}
                                                                        />
                                                                        {(globalLayout === "grid" || globalLayout === "dinamico") && <Form.Text className="text-muted small">En modo Grilla y Diseño Dinámico, puedes configurar el Nombre Comercial directamente en las celdas centrales.</Form.Text>}
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col md={6}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label className="fw-semibold">Cargar Logotipo de Empresa</Form.Label>
                                                                        <div className="d-flex gap-2">
                                                                            <Form.Control
                                                                                type="file"
                                                                                accept="image/*"
                                                                                onChange={handleSubirLogo}
                                                                                disabled={subiendoLogo}
                                                                                style={{ borderRadius: "8px" }}
                                                                            />
                                                                            {subiendoLogo && <Spinner animation="border" size="sm" className="align-self-center" />}
                                                                        </div>
                                                                    </Form.Group>
                                                                </Col>
                                                            </Row>

                                                            <Form.Group className="mb-3">
                                                                <Form.Label className="fw-semibold">URL del Logotipo Directo</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="https://..."
                                                                    value={logoUrl}
                                                                    onChange={(e) => setLogoUrl(e.target.value)}
                                                                    style={{ borderRadius: "8px" }}
                                                                />
                                                            </Form.Group>

                                                            {/* Personalización de la Columna Izquierda (Logo / RUC) */}
                                                            <h6 className="fw-bold text-secondary mt-3 mb-3 d-flex align-items-center">
                                                                <FaFileAlt className="me-2 text-primary" /> Columna Izquierda (Logotipo y RUC)
                                                            </h6>
                                                            <Row className="p-3 bg-light rounded border mb-4 g-2">
                                                                <Col md={8}>
                                                                    <Form.Group>
                                                                        <Form.Label className="small fw-semibold">Texto adicional bajo el Logo (ej: R.U.C.)</Form.Label>
                                                                        <Form.Control
                                                                            type="text"
                                                                            placeholder="Ej: R.U.C. 20601234567"
                                                                            value={logoSubTexto}
                                                                            onChange={(e) => setLogoSubTexto(e.target.value)}
                                                                            style={{ borderRadius: "8px" }}
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col md={4} className="d-flex align-items-end">
                                                                    <Form.Check
                                                                        type="switch"
                                                                        id="logo-subtexto-bold-global"
                                                                        label="Texto en Negrita"
                                                                        checked={logoSubTextoBold}
                                                                        onChange={(e) => setLogoSubTextoBold(e.target.checked)}
                                                                        className="fw-semibold mb-2"
                                                                    />
                                                                </Col>
                                                            </Row>

                                                            {/* Personalización de Grilla Dinámica si está seleccionada */}
                                                            {(globalLayout === "dinamico" || globalLayout === "grid") && (
                                                                <div className="mt-3">
                                                                    <Alert variant="info" className="py-2 border-0 small">
                                                                        <FaInfoCircle className="me-2" />
                                                                        Puedes agregar, editar y eliminar celdas libremente en ambas columnas.
                                                                    </Alert>
                                                                    {renderFilaCustomizer("centro", globalCentroRows, handleUpdateCelda, handleRemoveFila, handleAddFila, null)}
                                                                    {renderFilaCustomizer("derecha", globalDerechaRows, handleUpdateCelda, handleRemoveFila, handleAddFila, handleAjustarCeldasDerecha)}
                                                                </div>
                                                            )}

                                                            {/* Estilos del SGI */}
                                                            <h6 className="fw-bold text-secondary mt-4 mb-3 d-flex align-items-center">
                                                                <FaPalette className="me-2" /> Estilos Visuales de la Tabla SGI
                                                            </h6>
                                                            <Row className="p-3 bg-light rounded border mb-4 g-3">
                                                                <Col md={4}>
                                                                    <Form.Group>
                                                                        <Form.Label className="small fw-semibold">Color del Borde</Form.Label>
                                                                        <Form.Control
                                                                            type="color"
                                                                            value={globalBorderColor}
                                                                            onChange={(e) => setGlobalBorderColor(e.target.value)}
                                                                            className="form-control-color w-100"
                                                                            style={{ height: "38px", borderRadius: "8px" }}
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col md={4}>
                                                                    <Form.Group>
                                                                        <Form.Label className="small fw-semibold">Grosor de Borde</Form.Label>
                                                                        <Form.Select
                                                                            value={globalBorderWidth}
                                                                            onChange={(e) => setGlobalBorderWidth(e.target.value)}
                                                                            style={{ borderRadius: "8px" }}
                                                                        >
                                                                            <option value="1px">1px (Delgado)</option>
                                                                            <option value="2px">2px (Medio)</option>
                                                                            <option value="3px">3px (Grueso)</option>
                                                                            <option value="4px">4px (Muy Grueso)</option>
                                                                        </Form.Select>
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col md={4}>
                                                                    <Form.Group>
                                                                        <Form.Label className="small fw-semibold">Fondo de Celdas</Form.Label>
                                                                        <Form.Control
                                                                            type="color"
                                                                            value={globalBgColor}
                                                                            onChange={(e) => setGlobalBgColor(e.target.value)}
                                                                            className="form-control-color w-100"
                                                                            style={{ height: "38px", borderRadius: "8px" }}
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col md={6}>
                                                                    <Form.Group>
                                                                        <Form.Label className="small fw-semibold">Tipo de Letra (Font Family)</Form.Label>
                                                                        <Form.Select
                                                                            value={globalFontFamily}
                                                                            onChange={(e) => setGlobalFontFamily(e.target.value)}
                                                                            style={{ borderRadius: "8px" }}
                                                                        >
                                                                            <option value="Arial, sans-serif">Arial (Recomendado)</option>
                                                                            <option value="'Helvetica Neue', Helvetica, sans-serif">Helvetica</option>
                                                                            <option value="Verdana, sans-serif">Verdana</option>
                                                                            <option value="'Times New Roman', serif">Times New Roman</option>
                                                                            <option value="Georgia, serif">Georgia</option>
                                                                            <option value="monospace">Monospace</option>
                                                                        </Form.Select>
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col md={6}>
                                                                    <Form.Group>
                                                                        <Form.Label className="small fw-semibold">Color del Texto</Form.Label>
                                                                        <Form.Control
                                                                            type="color"
                                                                            value={globalTextColor}
                                                                            onChange={(e) => setGlobalTextColor(e.target.value)}
                                                                            className="form-control-color w-100"
                                                                            style={{ height: "38px", borderRadius: "8px" }}
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                            </Row>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Alert variant="warning" className="border-0 py-2 mb-3 small">
                                                                <FaInfoCircle className="me-2" />
                                                                <strong>Atención:</strong> En este modo editas el código HTML crudo. Asegúrate de conservar la estructura de tabla (<code>{`<table>, <tr>, <td>`}</code>) y las variables dinámicas de ser necesario.
                                                            </Alert>
                                                            <Form.Group className="mb-3">
                                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                                    <Form.Label className="fw-semibold mb-0">Código HTML de la Cabecera Global</Form.Label>
                                                                    <Button 
                                                                        variant="outline-danger" 
                                                                        size="sm" 
                                                                        onClick={() => restaurarPlantillaPorDefecto(true)}
                                                                        style={{ borderRadius: "6px" }}
                                                                    >
                                                                        Restaurar Diseño Base
                                                                    </Button>
                                                                </div>
                                                                <Form.Control
                                                                    as="textarea"
                                                                    rows={15}
                                                                    value={globalCustomHTML}
                                                                    onChange={(e) => setGlobalCustomHTML(e.target.value)}
                                                                    className="font-monospace text-dark bg-white"
                                                                    style={{ fontSize: "0.85rem", borderRadius: "8px", border: "1px solid #cbd5e1" }}
                                                                />
                                                            </Form.Group>
                                                        </>
                                                    )}

                                                    <div className="d-flex justify-content-end mt-4">
                                                        <Button
                                                            variant="primary"
                                                            onClick={guardarGlobal}
                                                            disabled={guardando}
                                                            className="d-flex align-items-center px-4"
                                                            style={{
                                                                borderRadius: "10px",
                                                                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                                                border: "none",
                                                            }}
                                                        >
                                                            {guardando ? <Spinner animation="border" size="sm" className="me-2" /> : <FaSave className="me-2" />}
                                                            Guardar Configuración Global
                                                        </Button>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>

                                        {/* PANEL DERECHO DE VISTA PREVIA GLOBAL */}
                                        <Col lg={5}>
                                            <Card className="shadow-sm border-0 sticky-top" style={{ borderRadius: "12px", top: "20px", zIndex: 5 }}>
                                                <Card.Header className="bg-dark text-white py-3 d-flex align-items-center justify-content-between">
                                                    <h6 className="mb-0 fw-bold d-flex align-items-center">
                                                        <FaRegEye className="me-2 text-warning" /> Vista Previa en Tiempo Real
                                                    </h6>
                                                    <Badge bg="secondary">Cabecera Global</Badge>
                                                </Card.Header>
                                                <Card.Body className="p-4" style={{ backgroundColor: "#f1f5f9" }}>
                                                    <Alert variant="info" className="py-2 border-0 small mb-3">
                                                        <FaInfoCircle className="me-2" />
                                                        Los placeholders se compilarán con datos demo globales.
                                                    </Alert>

                                                    <div className="bg-white p-3 rounded shadow-sm border" style={{ minHeight: "150px", overflowX: "auto" }}>
                                                        <div dangerouslySetInnerHTML={{ __html: compilarHTML(globalCustomHTML, false) }} />
                                                    </div>

                                                    <div className="mt-4 p-3 bg-white rounded border">
                                                        <h6 className="fw-bold text-secondary mb-2">Estructura Dinámica (SGI):</h6>
                                                        <p className="small text-muted mb-2">
                                                            El generador compila una tabla HTML de 3 columnas compatible con PDFs y la app móvil.
                                                        </p>
                                                        <div className="d-flex flex-wrap gap-2 mt-2">
                                                            <Badge bg="dark" className="font-monospace py-1 px-2">25% Logo</Badge>
                                                            <Badge bg="dark" className="font-monospace py-1 px-2">50% Centro</Badge>
                                                            <Badge bg="dark" className="font-monospace py-1 px-2">25% Derecha</Badge>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Tab>

                                {/* PESTAÑA CONFIGURACIÓN POR FORMATO */}
                                <Tab
                                    eventKey="formato"
                                    title={
                                        <span>
                                            <FaFileAlt className="me-2" />
                                            2. Configuración Específica por Formato
                                        </span>
                                    }
                                >
                                    <Row className="mt-3">
                                        <Col lg={7}>
                                            <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: "12px" }}>
                                                <Card.Body className="p-4">
                                                    <div className="d-flex justify-content-between align-items-center mb-4">
                                                        <h5 className="fw-bold mb-0 text-primary d-flex align-items-center">
                                                            <FaFileAlt className="me-2" /> Metadatos del Formato
                                                        </h5>
                                                        {selectedFormatoId && (
                                                            <div className="d-flex gap-2">
                                                                <Button
                                                                    variant={editModeFormato === "form" ? "primary" : "outline-primary"}
                                                                    size="sm"
                                                                    onClick={() => setEditModeFormato("form")}
                                                                    style={{ borderRadius: "8px" }}
                                                                >
                                                                    <FaTable className="me-1" /> Generador SGI (Recomendado)
                                                                </Button>
                                                                <Button
                                                                    variant={editModeFormato === "html" ? "primary" : "outline-primary"}
                                                                    size="sm"
                                                                    onClick={() => setEditModeFormato("html")}
                                                                    style={{ borderRadius: "8px" }}
                                                                >
                                                                    <FaCode className="me-1" /> Código Fuente HTML
                                                                </Button>
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* Selector de Formato */}
                                                    <Form.Group className="mb-4">
                                                        <Form.Label className="fw-bold text-dark">Seleccionar Formato SGI</Form.Label>
                                                        <Form.Select
                                                            value={selectedFormatoId}
                                                            onChange={(e) => setSelectedFormatoId(e.target.value)}
                                                            className="form-control-lg"
                                                            style={{ borderRadius: "10px", border: "2px solid #cbd5e1" }}
                                                        >
                                                            <option value="">Seleccione un formato del catálogo maestro...</option>
                                                            {formatos.map((f) => (
                                                                <option key={f.id} value={f.id}>
                                                                    [{f.id}] {f.title}
                                                                </option>
                                                            ))}
                                                        </Form.Select>
                                                    </Form.Group>

                                                    {selectedFormatoId ? (
                                                        <>
                                                            {editModeFormato === "form" ? (
                                                                <>
                                                                    <Row>
                                                                        <Col md={12} className="mb-3">
                                                                            <Form.Group>
                                                                                <Form.Label className="fw-bold text-secondary">Estructura / Diseño de Cabecera para Formato</Form.Label>
                                                                                <Form.Select
                                                                                    value={resolveLayoutValue(formatoLayout, formatoDerechaRows)}
                                                                                    onChange={(e) => handleSelectLayout(e.target.value, "formato")}
                                                                                    style={{ borderRadius: "10px", border: "2px solid #667eea" }}
                                                                                    className="form-control-lg fw-semibold"
                                                                                >
                                                                                    <option value="clasico">SGI Clásico (3 columnas, 4 metadatos apilados)</option>
                                                                                    <option value="grid2">SGI Grilla - 2 Celdas a la derecha (Logo spans 2 filas)</option>
                                                                                    <option value="grid3">SGI Grilla - 3 Celdas a la derecha (Logo spans 3 filas)</option>
                                                                                    <option value="grid4">SGI Grilla - 4 Celdas a la derecha (Logo spans 4 filas)</option>
                                                                                    <option value="dinamico">Diseño Dinámico por Filas (Personalizado total)</option>
                                                                                </Form.Select>
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col md={12}>
                                                                            <Form.Group className="mb-3">
                                                                                <Form.Label className="fw-semibold">Título del Formato</Form.Label>
                                                                                <Form.Control
                                                                                    type="text"
                                                                                    value={formatoTitulo}
                                                                                    onChange={(e) => setFormatoTitulo(e.target.value)}
                                                                                    style={{ borderRadius: "8px" }}
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col md={6}>
                                                                            <Form.Group className="mb-3">
                                                                                <Form.Label className="fw-semibold">Código del Formato SGI</Form.Label>
                                                                                <Form.Control
                                                                                    type="text"
                                                                                    placeholder="Ej. FOR-GH-006"
                                                                                    value={formatoCodigo}
                                                                                    onChange={(e) => setFormatoCodigo(e.target.value)}
                                                                                    style={{ borderRadius: "8px" }}
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col md={6}>
                                                                            <Form.Group className="mb-3">
                                                                                <Form.Label className="fw-semibold">Versión / Revisión</Form.Label>
                                                                                <Form.Control
                                                                                    type="text"
                                                                                    placeholder="Ej. 02"
                                                                                    value={formatoVersion}
                                                                                    onChange={(e) => setFormatoVersion(e.target.value)}
                                                                                    style={{ borderRadius: "8px" }}
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col md={6}>
                                                                            <Form.Group className="mb-3">
                                                                                <Form.Label className="fw-semibold">Fecha de Vigencia</Form.Label>
                                                                                <Form.Control
                                                                                    type="text"
                                                                                    placeholder="Ej. 16/07/2026"
                                                                                    value={formatoFecha}
                                                                                    onChange={(e) => setFormatoFecha(e.target.value)}
                                                                                    style={{ borderRadius: "8px" }}
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col md={6}>
                                                                            <Form.Group className="mb-3">
                                                                                <Form.Label className="fw-semibold">Páginas</Form.Label>
                                                                                <Form.Control
                                                                                    type="text"
                                                                                    placeholder="Ej. 1 de 2"
                                                                                    value={formatoPaginas}
                                                                                    onChange={(e) => setFormatoPaginas(e.target.value)}
                                                                                    style={{ borderRadius: "8px" }}
                                                                                    disabled={formatoLayout === "grid"}
                                                                                />
                                                                                {formatoLayout === "grid" && <Form.Text className="text-danger small">El diseño de Grilla tradicional no usa páginas a la derecha.</Form.Text>}
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </Row>

                                                                    {/* Personalización de la Columna Izquierda (Logo / RUC) para Formato */}
                                                                    <h6 className="fw-bold text-secondary mt-3 mb-3 d-flex align-items-center">
                                                                        <FaFileAlt className="me-2 text-primary" /> Columna Izquierda (Logotipo y RUC)
                                                                    </h6>
                                                                    <Row className="p-3 bg-light rounded border mb-4 g-2">
                                                                        <Col md={8}>
                                                                            <Form.Group>
                                                                                <Form.Label className="small fw-semibold">Texto adicional bajo el Logo (ej: R.U.C.)</Form.Label>
                                                                                <Form.Control
                                                                                    type="text"
                                                                                    placeholder="Ej: R.U.C. 20601234567"
                                                                                    value={formatoLogoSubTexto}
                                                                                    onChange={(e) => setFormatoLogoSubTexto(e.target.value)}
                                                                                    style={{ borderRadius: "8px" }}
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col md={4} className="d-flex align-items-end">
                                                                            <Form.Check
                                                                                type="switch"
                                                                                id="logo-subtexto-bold-formato"
                                                                                label="Texto en Negrita"
                                                                                checked={formatoLogoSubTextoBold}
                                                                                onChange={(e) => setFormatoLogoSubTextoBold(e.target.checked)}
                                                                                className="fw-semibold mb-2"
                                                                            />
                                                                        </Col>
                                                                    </Row>

                                                                    {/* Personalización de Grilla Dinámica para Formato */}
                                                                    {(formatoLayout === "dinamico" || formatoLayout === "grid") && (
                                                                        <div className="mt-3">
                                                                            <Alert variant="info" className="py-2 border-0 small">
                                                                                <FaInfoCircle className="me-2" /> Configura las celdas para este formato. La columna derecha permite seleccionar rápidamente de 2 a 4 celdas.
                                                                            </Alert>
                                                                            {renderFilaCustomizer("centro", formatoCentroRows, handleUpdateFormatoCelda, handleRemoveFormatoFila, handleAddFormatoFila, null)}
                                                                            {renderFilaCustomizer("derecha", formatoDerechaRows, handleUpdateFormatoCelda, handleRemoveFormatoFila, handleAddFormatoFila, handleAjustarCeldasDerecha)}
                                                                        </div>
                                                                    )}

                                                                    {/* Switch para personalizar estilos en el formato */}
                                                                    <Form.Check
                                                                        type="switch"
                                                                        id="personalizar-estilos-formato"
                                                                        label="Personalizar colores y bordes para este formato específico"
                                                                        checked={formatoPersonalizarEstilo}
                                                                        onChange={(e) => setFormatoPersonalizarEstilo(e.target.checked)}
                                                                        className="fw-semibold text-secondary mt-3 mb-3"
                                                                    />

                                                                    {formatoPersonalizarEstilo && (
                                                                        <Row className="p-3 bg-light rounded border mb-4 g-3">
                                                                            <Col md={4}>
                                                                                <Form.Group>
                                                                                    <Form.Label className="small fw-semibold">Color del Borde</Form.Label>
                                                                                    <Form.Control
                                                                                        type="color"
                                                                                        value={formatoBorderColor}
                                                                                        onChange={(e) => setFormatoBorderColor(e.target.value)}
                                                                                        className="form-control-color w-100"
                                                                                        style={{ height: "38px", borderRadius: "8px" }}
                                                                                    />
                                                                                </Form.Group>
                                                                            </Col>
                                                                            <Col md={4}>
                                                                                <Form.Group>
                                                                                    <Form.Label className="small fw-semibold">Grosor de Borde</Form.Label>
                                                                                    <Form.Select
                                                                                        value={formatoBorderWidth}
                                                                                        onChange={(e) => setFormatoBorderWidth(e.target.value)}
                                                                                        style={{ borderRadius: "8px" }}
                                                                                    >
                                                                                        <option value="1px">1px (Delgado)</option>
                                                                                        <option value="2px">2px (Medio)</option>
                                                                                        <option value="3px">3px (Grueso)</option>
                                                                                        <option value="4px">4px (Muy Grueso)</option>
                                                                                    </Form.Select>
                                                                                </Form.Group>
                                                                            </Col>
                                                                            <Col md={4}>
                                                                                <Form.Group>
                                                                                    <Form.Label className="small fw-semibold">Fondo de Celdas</Form.Label>
                                                                                    <Form.Control
                                                                                        type="color"
                                                                                        value={formatoBgColor}
                                                                                        onChange={(e) => setFormatoBgColor(e.target.value)}
                                                                                        className="form-control-color w-100"
                                                                                        style={{ height: "38px", borderRadius: "8px" }}
                                                                                    />
                                                                                </Form.Group>
                                                                            </Col>
                                                                            <Col md={6}>
                                                                                <Form.Group>
                                                                                    <Form.Label className="small fw-semibold">Tipo de Letra (Font Family)</Form.Label>
                                                                                    <Form.Select
                                                                                        value={formatoFontFamily}
                                                                                        onChange={(e) => setFormatoFontFamily(e.target.value)}
                                                                                        style={{ borderRadius: "8px" }}
                                                                                    >
                                                                                        <option value="Arial, sans-serif">Arial</option>
                                                                                        <option value="'Helvetica Neue', Helvetica, sans-serif">Helvetica</option>
                                                                                        <option value="Verdana, sans-serif">Verdana</option>
                                                                                        <option value="'Times New Roman', serif">Times New Roman</option>
                                                                                        <option value="Georgia, serif">Georgia</option>
                                                                                        <option value="monospace">Monospace</option>
                                                                                    </Form.Select>
                                                                                </Form.Group>
                                                                            </Col>
                                                                            <Col md={6}>
                                                                                <Form.Group>
                                                                                    <Form.Label className="small fw-semibold">Color del Texto</Form.Label>
                                                                                    <Form.Control
                                                                                        type="color"
                                                                                        value={formatoTextColor}
                                                                                        onChange={(e) => setFormatoTextColor(e.target.value)}
                                                                                        className="form-control-color w-100"
                                                                                        style={{ height: "38px", borderRadius: "8px" }}
                                                                                    />
                                                                                </Form.Group>
                                                                            </Col>
                                                                        </Row>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <Alert variant="warning" className="border-0 py-2 mb-3 small">
                                                                        <FaInfoCircle className="me-2" />
                                                                        Estás editando el código HTML de este formato. Si lo dejas vacío heredará el de la empresa.
                                                                    </Alert>
                                                                    <Form.Group className="mb-3">
                                                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                                                            <Form.Label className="fw-semibold mb-0">HTML Personalizado de este Formato</Form.Label>
                                                                            <Button 
                                                                                variant="outline-danger" 
                                                                                size="sm" 
                                                                                onClick={() => restaurarPlantillaPorDefecto(false)}
                                                                                style={{ borderRadius: "6px" }}
                                                                            >
                                                                                Restaurar Diseño Base
                                                                            </Button>
                                                                        </div>
                                                                        <Form.Control
                                                                            as="textarea"
                                                                            rows={15}
                                                                            value={formatoCustomHTML}
                                                                            onChange={(e) => setFormatoCustomHTML(e.target.value)}
                                                                            className="font-monospace text-dark bg-white"
                                                                            style={{ fontSize: "0.85rem", borderRadius: "8px", border: "1px solid #cbd5e1" }}
                                                                        />
                                                                    </Form.Group>
                                                                </>
                                                            )}

                                                            <div className="d-flex justify-content-between mt-4">
                                                                {formatoOriginalData ? (
                                                                    <Button
                                                                        variant="outline-danger"
                                                                        onClick={eliminarConfiguracionFormato}
                                                                        disabled={guardando}
                                                                        style={{ borderRadius: "10px" }}
                                                                    >
                                                                        Restablecer Formato (Heredar Global)
                                                                    </Button>
                                                                ) : <div />}

                                                                <Button
                                                                    variant="primary"
                                                                    onClick={guardarFormato}
                                                                    disabled={guardando}
                                                                    className="d-flex align-items-center px-4"
                                                                    style={{
                                                                        borderRadius: "10px",
                                                                        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                                                        border: "none",
                                                                    }}
                                                                >
                                                                    {guardando ? <Spinner animation="border" size="sm" className="me-2" /> : <FaSave className="me-2" />}
                                                                    Guardar Cabecera de Formato
                                                                </Button>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <div className="text-center py-5 text-muted">
                                                            <FaFileAlt size={48} className="mb-3 opacity-50" />
                                                            <p className="mb-0">Por favor, seleccione un formato de la lista superior para configurar su cabecera.</p>
                                                        </div>
                                                    )}
                                                </Card.Body>
                                            </Card>
                                        </Col>

                                        {/* PANEL DERECHO DE VISTA PREVIA DE FORMATO */}
                                        <Col lg={5}>
                                            <Card className="shadow-sm border-0 sticky-top" style={{ borderRadius: "12px", top: "20px", zIndex: 5 }}>
                                                <Card.Header className="bg-dark text-white py-3 d-flex align-items-center justify-content-between">
                                                    <h6 className="mb-0 fw-bold d-flex align-items-center">
                                                        <FaRegEye className="me-2 text-warning" /> Vista Previa en Tiempo Real
                                                    </h6>
                                                    <Badge bg="primary">Formato Seleccionado</Badge>
                                                </Card.Header>
                                                <Card.Body className="p-4" style={{ backgroundColor: "#f1f5f9" }}>
                                                    {selectedFormatoId ? (
                                                        <>
                                                            <Alert variant="success" className="py-2 border-0 small mb-3">
                                                                <FaInfoCircle className="me-2" />
                                                                Mostrando la cabecera que se aplicará a este formato específico.
                                                            </Alert>

                                                            {/* Mostrar vista previa del formato. Si no hay HTML específico, mostrar la global como fallback */}
                                                            <div className="bg-white p-3 rounded shadow-sm border" style={{ minHeight: "150px", overflowX: "auto" }}>
                                                                {formatoCustomHTML ? (
                                                                    <div dangerouslySetInnerHTML={{ __html: compilarHTML(formatoCustomHTML, true) }} />
                                                                ) : (
                                                                    <div>
                                                                        <small className="text-muted d-block mb-2 text-center">*(Heredando plantilla global ya que el HTML específico está vacío)*</small>
                                                                        <div dangerouslySetInnerHTML={{ __html: compilarHTML(globalCustomHTML, true) }} />
                                                                    </div>
                                                                )}
                                                            </div>

                                                            <div className="mt-4 p-3 bg-white rounded border">
                                                                <h6 className="fw-bold text-secondary mb-1">Heredar vs Personalizar:</h6>
                                                                <p className="small text-muted mb-0">
                                                                    Si no necesitas un diseño de cabecera distinto para este documento, puedes dejar el editor HTML vacío. El sistema aplicará la <strong>Cabecera Global de la Empresa</strong> completando el título y los códigos automáticamente.
                                                                </p>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <div className="text-center py-5 text-muted">
                                                            <FaRegEye size={48} className="mb-3 opacity-50" />
                                                            <p className="mb-0">Seleccione un formato para ver su vista previa.</p>
                                                        </div>
                                                    )}
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Tab>
                            </Tabs>
                        )}
                    </Card.Body>
                </Card>
            </Container>
        </div>
    );
}

export default EditorCabeceraSGI;
